<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn color="primary" elevation="0" @click="generateLinkExcelAppointments()">
          <v-icon left>mdi-file-download</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('appointment.buttons.generateExcel') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <div class="qa__card-wrapper mb-6" v-if="dashboardAppointmentsCount">
      <v-card class="qa__card qa__card--scheduled" elevation="0" outlined>
        <h5 class="qa__card-title">Agendados</h5>
        <h1 v-if="!isLoading" class="qa__card-numbers">
          {{ dashboardAppointmentsCount.scheduleds ? dashboardAppointmentsCount.scheduleds : '-' }}
        </h1>
        <v-progress-circular v-else class="mt-3" width="3" indeterminate />
      </v-card>

      <v-card class="qa__card qa__card--done" elevation="0" outlined>
        <h5 class="qa__card-title">Realizados</h5>
        <h1 v-if="!isLoading" class="qa__card-numbers">
          {{ dashboardAppointmentsCount.dones ? dashboardAppointmentsCount.dones : '-' }}
        </h1>
        <v-progress-circular v-else class="mt-3" width="3" indeterminate />
      </v-card>

      <v-card class="qa__card qa__card--average" elevation="0" outlined>
        <h5 class="qa__card-title">Média SLA</h5>
        <h1 v-if="!isLoading" class="qa__card-numbers">
          {{ dashboardAppointmentsCount.average_delivery_sla ? dashboardAppointmentsCount.average_delivery_sla : '-' }}
        </h1>
        <v-progress-circular v-else class="mt-3" width="3" indeterminate />
      </v-card>
    </div>
    <div>
      <v-card class="no-border  mb-6" elevation="0">
        <QAAppointmentDashboardFilters />
      </v-card>
    </div>

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        hide-default-header
        mobile-breakpoint="20"
        :headers="headers"
        :items="dashboardAppointments"
        :loading="isLoading"
        :items-per-page="150"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th v-for="header in headers" :width="header.width">
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span class="d-block" :style="{ width: header.width + 'px' }" v-on="on">
                    {{header.text}}
                  </span>
                </template>
                <span>{{header.complete}}</span>
              </v-tooltip>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <span class="font-weight-bold">
            {{ item.code }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          {{ $t(`type.${item.type}`) }}
        </template>
        <template v-slot:[`item.delivery_sla`]="{ item }">
          {{ item.delivery_sla !== null ? convertDays(item.delivery_sla) : '---' }}
        </template>
        <template v-slot:[`item.first_acceptance_sla`]="{ item }">
          {{ item.first_acceptance_sla !== null ? convertDays(item.first_acceptance_sla) : '---' }}
        </template>
        <template v-slot:[`item.first_appointment_sla`]="{ item }">
          {{ item.first_appointment_sla !== null ? convertDays(item.first_appointment_sla) : '---' }}
        </template>
        <template v-slot:[`item.delivery_and_first_appointment_difference`]="{ item }">
          {{ item.delivery_and_first_appointment_difference !== null ? convertDays(item.delivery_and_first_appointment_difference) : '---' }}
        </template>
        <template v-slot:[`item.first_appointment_date`]="{ item }">
          {{ item.first_appointment_date ? dayAndMonth(item.first_appointment_date) : '---' }}
        </template>
        <template v-slot:[`item.acceptance_date`]="{ item }">
          {{ item.acceptance_date !== null ? dayAndMonth(item.acceptance_date) : '---' }}
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ item.date ? dayAndMonth(item.date) : '---' }}
        </template>
        <template v-slot:[`item.date_created`]="{ item }">
          {{ item.date_created ? dayAndMonth(item.date_created) : '---' }}
        </template>
        <template v-slot:[`item.realty_codes`]="{ item }">
          <div v-if="item.realty_codes">
            <v-chip v-for="code in item.realty_codes" :key="code" class="ma-1" small>
              {{ code }}
            </v-chip>
          </div>
          <div v-else>---</div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :class="formatColors(item.status)" small>
            {{ $t(`status.${item.status}`) }}
          </v-chip>
        </template>
        <template v-slot:[`item.cancel_date`]="{ item }">
          {{ item.cancel_date ? dayAndMonth(item.cancel_date) : '---' }}
        </template>
        <template v-slot:[`item.cancel_reason`]="{ item }">
          <v-tooltip v-if="item.cancel_reason" top>
            <template v-slot:activator="{ on, attrs }">
              <span class="d-block text-truncate mw-200" v-bind="attrs" v-on="on">{{ item.cancel_reason }}</span>
            </template>
            <span>{{ item.cancel_reason }}</span>
          </v-tooltip>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.last_updated`]="{ item }">
          {{ item.last_updated ? dayAndMonth(item.last_updated) : '---' }}
        </template>
        <template v-slot:[`item.host_name`]="{ item }">
          {{ item.host_name ? item.host_name : '---' }}
        </template>
        <template v-slot:[`item.external_code`]="{ item }">
          {{ item.external_code ? item.external_code : '---' }}
        </template>
        <template v-slot:[`item.tags`]="{ item }">
          <QaAppointmentTags :appointment="item" />
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchDashboardAppointments" />
  </div>
</template>

<script>
import QAAppointmentDashboardFilters from '@/views/appointmentDashboard/components/QAAppointmentDashboardFilters'
import QaAppointmentTags from '@/views/appointmentDashboard/components/QaAppointmentTags'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { appointmentDashboardHeaders } from '@/views/appointmentDashboard/listHeaders'
import { catalogDate } from '@/util/catalog'
import { handleColors } from '@/util/colors'
import moment from 'moment'

export default {
  name: 'AppointmentDashboard',

  components: {
    QAAppointmentDashboardFilters,
    QaAppointmentTags,
  },

  data() {
    return {
      headers: appointmentDashboardHeaders,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'dashboardAppointments', 'dashboardAppointmentsCount']),
  },

  methods: {
    ...mapActions(['fetchDashboardAppointments', 'fetchDashboardAppointmentsCount', 'fetchTags', 'generateAppointmentDashboardReport', 'showErrorMessage']),
    ...mapMutations(['setIsLoading']),

    formatColors: handleColors,

    formatDate(date) {
      return date ? catalogDate(date) : '---'
    },

    generateLinkExcelAppointments() {
      this.setIsLoading(true)
      this.generateAppointmentDashboardReport()
          .then((response) => this.downloadExcel(response))
          .catch((error) => this.showErrorMessage(error.message))
          .finally(() => (this.setIsLoading(false)))
    },

    downloadExcel(response) {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel;charset=utf-8',
        }),
        url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Dashboard de Agendamentos.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    dayAndMonth(date) {
      return moment(date).format('DD/MM')
    },

    convertDays(hoursReceived) {
      const duration = moment.duration(hoursReceived, 'hours')
      const days = duration.days()
      const hours = duration.hours()

      if (days > 0 ) {
        if (hours > 0) {
          return `${days} dias e ${hours} horas`
        } else {
          return `${days} dias`
        }
      } else {
        return `${hours} dias`
      }
    }
  },

  mounted() {
    this.fetchDashboardAppointments()
    this.fetchDashboardAppointmentsCount()
    this.fetchTags()
  },
}
</script>

<style lang="scss" scoped>
.qa {
  &__card-wrapper {
    display: flex;
    gap: 20px;
  }

  &__card {
    width: 100%;
    max-width: 200px;
    padding: 10px 5px 5px;
    text-align: center;

    &--done {
      background-color: #DCF8D9 !important;
    }

    &--scheduled {
      background-color: #DDEEFF !important;
    }

    &--cancelled {
      background-color: #FFA4A9 !important;
    }

    &--average {
      background-color: #fdffa4 !important;
    }

    .mt-3 {
      opacity: 0.1;
    }
  }

  &__card-title {
    opacity: 0.4;
    font-weight: 900;
  }

  &__card-numbers {
    opacity: 0.8;
    font-size: 48px;
    font-weight: 500;
    line-height: 120%;
  }
}

.text-truncate {
  cursor: help;
}
</style>
